import { render, staticRenderFns } from "./StrategyStats.vue?vue&type=template&id=3901219f&scoped=true"
import script from "./StrategyStats.vue?vue&type=script&lang=js"
export * from "./StrategyStats.vue?vue&type=script&lang=js"
import style0 from "./StrategyStats.vue?vue&type=style&index=0&id=3901219f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3901219f",
  null
  
)

export default component.exports